import React from 'react';

const MarkdownContent = ({ content }) => {
  if (!content) return null;

  // Simple markdown parser for basic formatting
  const parseMarkdown = (text) => {
    let html = text;

    // Headers
    html = html.replace(/^### (.*$)/gim, '<h3 class="text-xl font-bold text-gray-800 mt-6 mb-3">$1</h3>');
    html = html.replace(/^## (.*$)/gim, '<h2 class="text-2xl font-bold text-gray-800 mt-8 mb-4">$1</h2>');
    html = html.replace(/^# (.*$)/gim, '<h1 class="text-3xl font-bold text-gray-800 mt-8 mb-4">$1</h1>');

    // Bold
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold text-gray-800">$1</strong>');

    // Italic
    html = html.replace(/\*(.*?)\*/g, '<em class="italic">$1</em>');

    // Code inline
    html = html.replace(/`([^`]+)`/g, '<code class="bg-gray-100 px-2 py-1 rounded text-sm font-mono text-blue-600">$1</code>');

    // Lists - numbered
    const lines = html.split('\n');
    let inList = false;
    let listItems = [];
    let result = [];

    lines.forEach((line, index) => {
      const numberedMatch = line.match(/^\d+\.\s+(.+)$/);
      const bulletMatch = line.match(/^-\s+(.+)$/);

      if (numberedMatch) {
        if (!inList) {
          inList = true;
          listItems = [];
        }
        listItems.push(`<li class="ml-6 mb-2 text-gray-700">${numberedMatch[1]}</li>`);
      } else if (bulletMatch) {
        if (!inList) {
          inList = true;
          listItems = [];
        }
        listItems.push(`<li class="ml-6 mb-2 text-gray-700 list-disc">${bulletMatch[1]}</li>`);
      } else {
        if (inList && listItems.length > 0) {
          const listType = listItems[0].includes('list-disc') ? 'ul' : 'ol';
          result.push(`<${listType} class="list-${listType === 'ul' ? 'disc' : 'decimal'} space-y-2 mb-4 ml-4">${listItems.join('')}</${listType}>`);
          listItems = [];
          inList = false;
        }
        if (line.trim()) {
          result.push(line);
        }
      }
    });

    if (inList && listItems.length > 0) {
      const listType = listItems[0].includes('list-disc') ? 'ul' : 'ol';
      result.push(`<${listType} class="list-${listType === 'ul' ? 'disc' : 'decimal'} space-y-2 mb-4 ml-4">${listItems.join('')}</${listType}>`);
    }

    html = result.join('\n');

    // Paragraphs
    html = html.split('\n\n').map(para => {
      if (para.trim() && !para.trim().startsWith('<')) {
        return `<p class="mb-4 text-gray-700 leading-relaxed">${para.trim()}</p>`;
      }
      return para;
    }).join('');

    // Line breaks within paragraphs
    html = html.replace(/\n/g, '<br />');

    return html;
  };

  return (
    <div 
      className="prose prose-lg max-w-none"
      dangerouslySetInnerHTML={{ __html: parseMarkdown(content) }}
    />
  );
};

export default MarkdownContent;
